import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import {
  SUSTAINABILITY_METRICS,
  ECO_PACKAGING_MATERIALS_COPY,
  LOW_CARBON_ORDER_DEFINITION_COPY,
} from "../data/sustainabilityMetrics";
import ImpactStatCard from "./ImpactStatCard";

/** Renders a "coming soon" stat panel while SUSTAINABILITY_METRICS is null — the explanatory copy and CTA are real and always shown. */
export default function EcoPackagingImpact() {
  return (
    <div>
      {SUSTAINABILITY_METRICS ? (
        <div className="grid gap-6 sm:grid-cols-2">
          <ImpactStatCard stat={SUSTAINABILITY_METRICS.ecoPackagingAdoption} />
          <ImpactStatCard stat={SUSTAINABILITY_METRICS.lowCarbonOrders} />
        </div>
      ) : (
        <div className="mx-auto max-w-md rounded-2xl bg-foam-100 p-8 text-center">
          <p className="text-sm text-ocean-800/60">
            Adoption stats for eco-packaging and low-carbon orders will appear here once our metrics
            pipeline is live.
          </p>
        </div>
      )}

      <div className="mt-8 grid gap-6 sm:grid-cols-2">
        <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5">
          <h3 className="font-display font-semibold text-ocean-950">What's in eco-packaging?</h3>
          <p className="mt-2 text-sm leading-relaxed text-ocean-800/70">{ECO_PACKAGING_MATERIALS_COPY}</p>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5">
          <h3 className="font-display font-semibold text-ocean-950">What makes an order "low-carbon"?</h3>
          <p className="mt-2 text-sm leading-relaxed text-ocean-800/70">{LOW_CARBON_ORDER_DEFINITION_COPY}</p>
        </div>
      </div>

      <div className="mt-8 flex flex-col items-center gap-3 rounded-2xl bg-teal-400/10 p-6 text-center">
        <Leaf className="h-5 w-5 text-teal-600" strokeWidth={1.5} />
        <p className="max-w-md text-sm text-ocean-800/80">
          Opt into eco-packaging and low-carbon delivery windows right from the ZenFresh customer app.
        </p>
        <Link
          to="/#app-download"
          className="text-sm font-semibold text-teal-600 hover:text-teal-700"
        >
          Get the app
        </Link>
      </div>
    </div>
  );
}
